<template>
  <label class="min-h-24 block" :for="'delivery-radio-' + randomId" :data-testid="props.dataTestid + '-radio-label'">
  <TsMedia append-class="border-[1px] p-3 min-h-28 rounded-xl hover:bg-info/10 has-[:checked]:border-info cursor-pointer has-[:disabled]:cursor-not-allowed">
    <TsMediaStart append-class="mr-2 md:mr-4">
      <input
        :id="'delivery-radio-' + randomId"
        :data-testid="props.dataTestid + '-radio-input'"
        type="radio"
        v-model="modelValue"
        v-bind="$attrs"
        :class="baseInputClass"
      />
    </TsMediaStart>
    <TsMediaContent>
      <div class="flex items-center gap-4">
        
        <div>
          <TsImage
            src="/images/customer-support-track-order.png"
            alt="add-to-trolley-modal-delivery-icon"
            width="32"
            class="shrink-0 inline"
            loading="lazy"
          />
          
          <span v-if="isOutOfStock">
            <TsTypography as="span" variant="h4" append-class="text-idle-black capitalize ml-2">
              {{useTranslation("delivery" , "Bezorgen")}} 
            </TsTypography>
            <TsTypography append-class="mt-1 text-danger mb-0" variant="h5" weight="normal" :data-testid="props.dataTestid + '-out-of-stock-tag'">
              {{ useTranslation("outOfStockAt" ,"Niet op voorraad") }}
            </TsTypography>
          </span>

          <span v-else>
            <TsTypography as="span" variant="h4" append-class="text-idle-black ml-2">
              <span class="text-primary">{{useTranslation("delivery","Bezorgen")}}</span>
            </TsTypography>
            <TsTypography append-class="mt-1 text-success">
              <span class="font-semibold">{{ deliveryStock }} {{useTranslation('PLP-modal-stock','voorraad')}}</span>
              {{useTranslation('PLP-modal-avaliableForDelivery','Beschikbaar voor bezorging')}}
            </TsTypography>
            <span v-if="isDirectShip">
              <TsTypography weight="semibold" v-html="useTranslation('directshipEstimation', 'Dit product wordt binnen 3 werkdagen geleverd')" />
            </span>
            <span v-else>
              <TsTypography v-html="useTranslation(orderTranslationObject.key, orderTranslationObject.fallback)" />
            </span>
          </span>
        </div>

      </div>
    </TsMediaContent>
  </TsMedia>
  </label>
</template>

<script lang="ts" setup generic="T">
import { useTranslation } from "~/composables/useTranslation";
import { getOrderMessage } from "~/utils/formatMessage";

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

type Props = {
  deliveryStock?: string;
  isOutOfStock?: boolean;
  isDirectShip?: boolean;
  dataTestid: string;
};
const props = defineProps<Props>();

defineOptions({
  inheritAttrs: false,
});

const modelValue = defineModel<T>();
const orderTranslationObject = getOrderMessage();

const baseInputClass ="size-5 text-info disabled:cursor-not-allowed bg-transparent focus:ring-info-border focus:ring-2";

// random ID for each Vue Instance
const randomId = ref<string>("");

onMounted(() => {
  randomId.value = useRandomUUID();
});

</script>
